import {
  createCampaignTypeAPI,
  createChannelAPI,
  deleteCampaignTypeAPI,
  deleteChannelAPI,
  getCampaignTypeDetailsAPI,
  getCampaignTypesAPI,
  getChannelDetailsAPI,
  getChannelsAPI,
  updateCampaignTypeAPI,
  updateChannelAPI,
} from "@/services";
import { ChannelType, ICampaignType } from "@/types";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getChannels = createAsyncThunk(
  "campaign/getChannels",
  async () => {
    try {
      const { data } = await getChannelsAPI();
      return data;
    } catch (error: any) {
      console.log("error: ", error);
      throw new Error(error.message);
    }
  },
);

export const getChannelDetails = createAsyncThunk(
  "campaign/getChannelDetails",
  async (id: number) => {
    try {
      const { data } = await getChannelDetailsAPI(id);
      return data;
    } catch (error: any) {
      console.log("error: ", error);
      throw new Error(error.message);
    }
  },
);

export const createChannel = createAsyncThunk(
  "campaign/createChannel",
  async (data: ChannelType) => {
    try {
      await createChannelAPI(data);
    } catch (error: any) {
      console.log("error: ", error);
      throw new Error(error.message);
    }
  },
);

export const updateChannel = createAsyncThunk(
  "campaign/updateChannel",
  async (data: ChannelType) => {
    try {
      await updateChannelAPI(data);
    } catch (error: any) {
      console.log("error: ", error);
      throw new Error(error.message);
    }
  },
);

export const deleteChannel = createAsyncThunk(
  "campaign/deleteChannel",
  async (id: number) => {
    try {
      await deleteChannelAPI(id);
    } catch (error: any) {
      console.log("error: ", error);
      throw new Error(error.message);
    }
  },
);

// =============
export const getCampaignTypes = createAsyncThunk(
  "campaign/getCampaignTypes",
  async () => {
    try {
      const { data } = await getCampaignTypesAPI();
      return data;
    } catch (error: any) {
      console.log("error: ", error);
      throw new Error(error.message);
    }
  },
);

export const getCampaignTypeDetails = createAsyncThunk(
  "campaign/getCampaignTypeDetails",
  async (id: number) => {
    try {
      const { data } = await getCampaignTypeDetailsAPI(id);
      return data;
    } catch (error: any) {
      console.log("error: ", error);
      throw new Error(error.message);
    }
  },
);

export const createCampaignType = createAsyncThunk(
  "campaign/createCampaignType",
  async (data: ICampaignType) => {
    try {
      await createCampaignTypeAPI(data);
    } catch (error: any) {
      console.log("error: ", error);
      throw new Error(error.message);
    }
  },
);

export const updateCampaignType = createAsyncThunk(
  "campaign/updateCampaignType",
  async (data: ICampaignType) => {
    try {
      await updateCampaignTypeAPI(data);
    } catch (error: any) {
      console.log("error: ", error);
      throw new Error(error.message);
    }
  },
);

export const deleteCampaignType = createAsyncThunk(
  "campaign/deleteCampaignType",
  async (id: number) => {
    try {
      await deleteCampaignTypeAPI(id);
    } catch (error: any) {
      console.log("error: ", error);
      throw new Error(error.message);
    }
  },
);
